<template>
	<div>
		<v-alert icon="mdi-shield-lock-outline" prominent text type="info">
			<v-row>
				<v-col cols="12">
					{{ transactionTitle }}
				</v-col>
			</v-row>
		</v-alert>
		<v-container>
			<div>
				<v-row>
					<v-col cols="12" md="7" style="">

						<v-form ref="form" class="mx-2" lazy-validation>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-money ref="amount" v-model="localData.amount" :label="'*مبلغ'" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']" required />
								</v-col>
								<v-col cols="12" md="6">
									<div>
										<div>تاریخ واریز*</div>
										<date-picker ref="saveDate" v-model="localData.saveDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :rules="[() => !!localData.saveDate || 'تاریخ واریز را به صورت صحیح وارد کنید']" />
									</div>
								</v-col>
							</v-row>
							<v-row v-if="localData.paymentMethod === 3">
								<v-col cols="12" md="6">
									<v-text-field ref="goldWeight" v-model="localData.goldWeight" :label="'وزن طلا*'" :error-messages="errorMessages" :rules="[() => localData.goldWeight > 0 || 'وزن طلا را به صورت صحیح وارد کنید']" type="number" required />
								</v-col>
								<v-col cols="12" md="6">
									<v-text-money ref="goldRate" v-model="localData.goldRate" :label="'قیمت واحد طلا*'" :error-messages="errorMessages" :rules="[() => localData.goldRate > 0 || 'قیمت واحد طلا را به صورت صحیح وارد کنید']" required />
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && loans && loans.length">
									<div v-if="localData.sponsoredLoan" style="margin-bottom: -15px;">بابت وام اسپانسری</div>
									<v-select v-model="localData.sponsoredLoan" clearable required single-line return-object :items="loans" label="بابت وام اسپانسری" item-text="title" item-value="id" :error-messages="errorMessages" />
								</v-col>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && localData.userLoan">
									<div v-if="localData.agent" style="margin-bottom: -15px;">نماینده</div>
									<v-combobox v-model="localData.agent" clearable :items="agents" label="نماینده" single-line return-object :error-messages="errorMessages" item-text="businessName" item-value="id" />
								</v-col>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && localData.userLoan">
									<div v-if="localData.userLoan" style="margin-bottom: -15px;">وام نماینده</div>
									<v-combobox v-model="localData.userLoan" clearable :items="userLoans" label="وام نماینده" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
								</v-col>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && localData.userLoanRequest">
									<div style="margin-bottom: -15px;">وضعیت مشتری</div>
									<v-select v-model="localData.customerStatus" :items="customerStatuses" style="" class="" label="انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
								</v-col>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && localData.userLoanRequest">
									<div style="margin-bottom: -15px;">وضعیت نماینده</div>
									<v-select v-model="localData.agentStatus" :items="agentStatuses" style="" class="" label="انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
								</v-col>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && localData.userLoanContact">
									<div v-if="localData.contact" style="margin-bottom: -15px;">طرف حساب</div>
									<v-combobox v-model="localData.contact" clearable :items="contacts" label="طرف حساب" single-line return-object :error-messages="errorMessages" item-text="businessName" item-value="id" />
								</v-col>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && localData.userLoanContact">
									<div v-if="localData.userLoanContact" style="margin-bottom: -15px;">وام</div>
									<v-combobox v-model="localData.userLoanContact" clearable :items="userLoanContacts" label="وام" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
								</v-col>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && localData.customerMarketerCommission">
									<div style="margin-bottom: -15px;">بازاریاب</div>
									<v-combobox v-model="localData.customerMarketerCommission.marketer" clearable :items="marketers" label="بازاریاب" single-line return-object :error-messages="errorMessages" item-text="businessName" item-value="id" />
								</v-col>
								<v-col cols="12" md="6" v-if="localData.isWithdraw && localData.customerMarketerCommission">
									<div v-if="localData.customerMarketerCommission" style="margin-bottom: -15px;">وام</div>
									<v-combobox v-model="localData.customerMarketerCommission" clearable :items="customerMarketerCommissions" label="وام" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="12">
									<v-text-field ref="description" v-model="localData.description" :label="'توضیحات'" :error-messages="errorMessages" />
								</v-col>
								<v-col cols="12" md="12" v-if="!localData.isWithdraw">
									<v-checkbox color="secondary" v-model="localData.isUnknown" label="طرف حساب تراکنش نامعلوم" />
								</v-col>
							</v-row>
						</v-form>
					</v-col>
					<v-col cols="12" md="5">
						<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
							<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
							<span>فایل پیوست</span>
						</div>
						<ImageUploader ref="imageUploader" v-model="localData.base64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base64)" @delete="() => localData.fileName = ''" />
						<ImageUploader v-if="showMore" ref="imageUploader2" class="mt-5" v-model="localData.base642" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base642)" @delete="() => localData.fileName2 = ''" />
						<ImageUploader v-if="showMore" ref="imageUploader3" class="mt-5" v-model="localData.base643" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base643)" @delete="() => localData.fileName3 = ''" />
						<div class="text-center mt-3" v-if="!showMore">
							<v-btn text color="secondary" x-small @click="showMore = true">
								<v-icon class="ml-1" small>mdi-plus</v-icon>
								پیوست های بیشتر
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</div>
			<v-card color="#eee" class="mb-3 px-3 mt-6" v-if="this.data.isWithdraw && this.data.paymentMethod === 2 && checkActivePart('onlineMoneyTransfer')">
				<v-row>
					<v-col cols="12" md="12" class="d-flex justify-center" style="border-bottom: 1px dashed #ccc">
						<v-switch v-model="onlineMoneyTransferActive" label="انتقال وجه بین بانکی آنلاین" color="secondary" :value="true" hide-details></v-switch>
					</v-col>
				</v-row>
				<div v-if="onlineMoneyTransferActive" class="mt-6">
					<v-row class="d-flex justify-center">
						<v-col cols="12" md="10" class="" style="">
							<v-row>
								<v-col cols="12" md="5" class="d-flex flex-column justify-center">
									<div :class="`${onlineMoneyTransferColor}--text`" style="background: white;
										border-radius: 50%;
										width: 210px;
										height: 210px;
										flex-direction: column;
										justify-content: center;
										border: 1px solid #ddd;
										display: inline-flex;">
										<div>
											<v-icon size="100" :color="onlineMoneyTransferColor">{{ onlineMoneyTransferIcon }}</v-icon>
										</div>
										<div class="text-center" style="margin-top: 15px">
											انتقال وجه آنلاین
											<br />
											سامانه شاهین (بانک صادرات)
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="7">
									<v-form ref="formOnlineTransfer" class="mx-2" lazy-validation v-if="!onlineMoneyTransfer.shahinResult">
										<v-row class="pt-4">
											<v-col cols="12" md="12" class="py-0">
												<div v-if="onlineMoneyTransfer.shahin.sourceAccount">از شماره حساب:</div>
												<div class="d-flex">
													<v-select class="pt-0 mt-0" v-model="onlineMoneyTransfer.shahin.sourceAccount" clearable single-line :items="bankAccounts" :label="!onlineMoneyTransfer.shahin.sourceAccount ? 'از شماره حساب' : ''" :error-messages="errorMessages" :rules="[(val) => !!val || 'از شماره حساب را انتخاب کنید']" required />
													<v-btn plain color="secondary" class="mt-2" @click="dialogBankAccounts = true">
														شماره حساب ها
													</v-btn>
												</div>
											</v-col>
											<v-col cols="12" md="12" class="py-0">
												<div v-if="toAccounts.length">
													<div v-if="onlineMoneyTransfer.shahin.destinationAccountNumber">به شماره شبا:</div>
													<v-select v-model="onlineMoneyTransfer.shahin.destinationAccountNumber" class="pt-0 mt-0" clearable single-line :items="toAccounts" :label="!onlineMoneyTransfer.shahin.destinationAccountNumber ? 'به شماره شبا' : ''" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره شبا را وارد کنید']" required />
												</div>
												<v-text-field v-else v-model="onlineMoneyTransfer.shahin.destinationAccountNumber" class="left-input" :label="'به شماره شبا'" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره شبا را وارد کنید']" required>
													<template v-slot:append-outer>
														<span class="pt-1">IR</span>
													</template>
												</v-text-field>
											</v-col>
											<v-col cols="12" md="12" class="d-flex py-0">
												<v-text-field v-model="onlineMoneyTransfer.shahin.destinationAccountName" class="ml-2" :label="'استعلام شبا'" :error-messages="errorMessages" :rules="[(val) => !!val || 'استعلام شبا الزامی است']" required />
												<v-btn @click="ibanInquiry" small class="mt-5 mb-2" :loading="ibanInquiryLoading" color="secondary" dark>استعلام شماره شبا</v-btn>
											</v-col>
											<v-col cols="12" md="12" class="py-0">
												<v-combobox v-model="onlineMoneyTransfer.shahin.destinationBank" :return-object="false" class="pt-0 mt-0" clearable single-line :items="banks" :label="'بانک مقصد'" :error-messages="errorMessages" :rules="[(val) => !!val || 'بانک مقصد را انتخاب کنید']" item-text="title" item-value="id" required />
											</v-col>
											<v-col cols="12" md="12" class="py-0">
												<v-select v-model="onlineMoneyTransfer.shahin.transferType" class="pt-0 mt-0" clearable single-line :items="transferTypes" :label="'نوع انتقال'" :error-messages="errorMessages" :rules="[(val) => !!val || 'نوع انتقال را انتخاب کنید']" item-text="title" item-value="id" required />
											</v-col>
											<v-col cols="12" md="12" class="py-0">
												<v-select v-model="onlineMoneyTransfer.shahin.babat" class="pt-0 mt-0" clearable single-line :items="babats" :label="'بابت'" :error-messages="errorMessages" :rules="[(val) => !!val || 'بابت را انتخاب کنید']" item-text="title" item-value="id" required />
											</v-col>
											<v-col cols="12" md="12" class="d-flex py-0">
												<v-text-field v-model="onlineMoneyTransfer.otp" class="ml-2" :label="'رمز پیامکی'" maxlength="5" :error-messages="errorMessages" :rules="[(val) => ignoreOtpValidation || !!val || 'رمز پیامکی را وارد کنید']" required />
												<v-btn v-if="sendCodeVisible" small @click="sendOTP" class="mt-5 mb-2" :loading="otpLoading" color="secondary" dark>دریافت رمز پیامکی</v-btn>
												<Countdown class="black--text fs-h3 mt-4" @finish="countDownFinished" ref="countdown" />
											</v-col>
											<v-col cols="12" md="12">
												<div v-show="validationMsg" class="pink pa-2 mt-2 white--text" style="border-radius: 10px">
													{{ validationMsg }}
												</div>
											</v-col>
										</v-row>
									</v-form>
									<div v-else>
										<v-card color="#cdffcf" v-if="onlineMoneyTransfer.isSuccess" class="pa-3">
											<h3 class="text-center" style="border-bottom:1px dashed green;margin-bottom:10px;padding-bottom:5px">رسید انتقال وجه موفق
											</h3>
											<div class="pa-2">
												مبلغ: {{ String(onlineMoneyTransfer.shahinResult.amount).toPriceFormat() }} ریال
											</div>
											<div class="pa-2">
												زمان تراکنش: {{ onlineMoneyTransfer.shahin.transactionTime }}
											</div>
											<div class="pa-2">
												حساب مبدا: {{ onlineMoneyTransfer.shahin.respObject.sourceAccountNumber }}
											</div>
											<div class="pa-2">
												حساب مقصد: {{ onlineMoneyTransfer.shahin.respObject.destinationAccountNumber }}
											</div>
											<div class="pa-2">
												نام صاحب حساب مقصد: {{ onlineMoneyTransfer.shahin.destinationAccountName }}
											</div>
											<div class="pa-2">
												شماره پیگیری: {{ onlineMoneyTransfer.shahin.respObject.traceNumber }}
											</div>
											<div class="pa-2">
												شماره مرجع: {{ onlineMoneyTransfer.shahin.respObject.transferType }}
											</div>
										</v-card>
										<v-card color="#ffcdcd" class="pa-3" v-else>
											<h3 class="text-center" style="border-bottom:1px dashed red;padding-bottom:5px">تراکنش ناموفق</h3>
											<div class="pa-2">
												<b>مبلغ:</b> {{ String(onlineMoneyTransfer.shahinResult.amount).toPriceFormat() }} ریال
											</div>
											<div class="pa-2">
												زمان تراکنش: {{ onlineMoneyTransfer.shahin.transactionTime }}
											</div>
											<div class="pa-2">
												حساب مبدا: {{ onlineMoneyTransfer.shahin.sourceAccount }}
											</div>
											<div class="pa-2">
												حساب مقصد: {{ onlineMoneyTransfer.shahin.destinationAccountNumber }}
											</div>
											<div class="pa-2">
												نام صاحب حساب مقصد: {{ onlineMoneyTransfer.shahin.destinationAccountName }}
											</div>
											<div class="pa-2">
												شماره پیگیری: {{ onlineMoneyTransfer.shahin.respObject ? onlineMoneyTransfer.shahin.respObject.traceNumber : '' }}
											</div>
										</v-card>
										<div class="text-center mt-3" v-if="!onlineMoneyTransfer.isSuccess">
											<v-btn color="secondary" dark @click="retryOnlineMoneyTransfer">تلاش مجدد</v-btn>
										</div>
									</div>
								</v-col>
							</v-row>

						</v-col>
					</v-row>
					<v-row class="d-flex justify-center" v-if="false">
						<v-col cols="12" md="10" class="" style="">
							<v-row>
								<v-col cols="12" md="5" class="d-flex flex-column justify-center">
									<div :class="`${onlineMoneyTransferColor}--text`" style="background: white;
										border-radius: 50%;
										width: 210px;
										height: 210px;
										flex-direction: column;
										justify-content: center;
										border: 1px solid #ddd;
										display: inline-flex;">
										<div>
											<v-icon size="130" :color="onlineMoneyTransferColor">{{ onlineMoneyTransferIcon }}</v-icon>
										</div>
										<div class="text-center" style="margin-top: 15px">
											انتقال وجه آنلاین
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="7">
									<v-form ref="formOnlineTransfer" class="mx-2" lazy-validation v-if="!onlineMoneyTransfer.eFardaResult">
										<v-row class="pt-4">
											<v-col cols="12" md="12" class="py-0">
												<div v-if="onlineMoneyTransfer.from">از شماره حساب:</div>
												<div class="d-flex">
													<v-select class="pt-0 mt-0" v-model="onlineMoneyTransfer.from" clearable single-line :items="bankAccounts" :label="!onlineMoneyTransfer.from ? 'از شماره حساب' : ''" :error-messages="errorMessages" :rules="[(val) => !!val || 'از شماره حساب را انتخاب کنید']" required />
													<v-btn plain color="secondary" class="mt-2" @click="dialogBankAccounts = true">
														شماره حساب ها
													</v-btn>
												</div>
											</v-col>
											<v-col cols="12" md="12" class="py-0">
												<div v-if="toAccounts.length">
													<div v-if="onlineMoneyTransfer.to">به شماره شبا:</div>
													<v-select v-model="onlineMoneyTransfer.to" class="pt-0 mt-0" clearable single-line :items="toAccounts" :label="!onlineMoneyTransfer.to ? 'به شماره شبا' : ''" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره شبا را وارد کنید']" required />
												</div>
												<v-text-field v-else v-model="onlineMoneyTransfer.to" class="left-input" :label="'به شماره شبا'" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره شبا را وارد کنید']" required>
													<template v-slot:append-outer>
														<span class="pt-1">IR</span>
													</template>
												</v-text-field>
											</v-col>
											<v-col cols="12" md="12" class="d-flex py-0">
												<v-text-field v-model="onlineMoneyTransfer.toName" class="ml-2" :label="'استعلام شبا'" :error-messages="errorMessages" :rules="[(val) => !!val || 'استعلام شبا الزامی است']" required />
												<v-btn @click="ibanInquiry" small class="mt-3 mb-2" :loading="ibanInquiryLoading" color="secondary" dark>استعلام شماره شبا</v-btn>
											</v-col>
											<v-col cols="12" md="12" class="d-flex py-0">
												<v-text-field v-model="onlineMoneyTransfer.otp" class="ml-2" :label="'رمز پیامکی'" maxlength="5" :error-messages="errorMessages" :rules="[(val) => ignoreOtpValidation || !!val || 'رمز پیامکی را وارد کنید']" required />
												<v-btn v-if="sendCodeVisible" small @click="sendOTP" class="mt-1 mb-2" :loading="otpLoading" color="secondary" dark>دریافت رمز پیامکی</v-btn>
												<Countdown class="black--text fs-h3 mt-4" @finish="countDownFinished" ref="countdown" />
											</v-col>
											<v-col cols="12" md="12">
												<div v-show="validationMsg" class="pink pa-2 mt-2 white--text" style="border-radius: 10px">
													{{ validationMsg }}
												</div>
											</v-col>
										</v-row>
									</v-form>
									<div v-else>
										<v-card color="#cdffcf" v-if="onlineMoneyTransfer.isSuccess" class="pa-3">
											<h3 class="text-center" style="border-bottom:1px dashed green;margin-bottom:10px;padding-bottom:5px">رسید انتقال وجه موفق
											</h3>
											<div class="pa-2">
												مبلغ: {{ String(onlineMoneyTransfer.eFardaResult.amount).toPriceFormat() }} ریال
											</div>
											<div class="pa-2">
												زمان تراکنش: {{ onlineMoneyTransfer.eFardaResult.doTime }}
											</div>
											<div class="pa-2">
												حساب مبدا: {{ onlineMoneyTransfer.from }}
											</div>
											<div class="pa-2">
												حساب مقصد: {{ onlineMoneyTransfer.to }}
											</div>
											<div class="pa-2">
												نام صاحب حساب مقصد: {{ onlineMoneyTransfer.toName }}
											</div>
											<div class="pa-2">
												شماره پیگیری: {{ onlineMoneyTransfer.eFardaResult.traceNumber }}
											</div>
											<div class="pa-2">
												شماره مرجع: {{ onlineMoneyTransfer.eFardaResult.refNumber }}
											</div>
											<div class="pa-2">
												توضیحات: {{ onlineMoneyTransfer.eFardaResult.description }}
											</div>
										</v-card>
										<v-card color="#ffcdcd" class="pa-3" v-else>
											<h3 class="text-center" style="border-bottom:1px dashed red;padding-bottom:5px">تراکنش ناموفق</h3>
											<div class="pa-2">
												<b>مبلغ:</b> {{ String(onlineMoneyTransfer.eFardaResult.amount).toPriceFormat() }} ریال
											</div>
											<div class="pa-2">
												زمان تراکنش: {{ onlineMoneyTransfer.eFardaResult.doTime }}
											</div>
											<div class="pa-2">
												حساب مبدا: {{ onlineMoneyTransfer.from }}
											</div>
											<div class="pa-2">
												حساب مقصد: {{ onlineMoneyTransfer.to }}
											</div>
											<div class="pa-2">
												نام صاحب حساب مقصد: {{ onlineMoneyTransfer.toName }}
											</div>
											<div class="pa-2">
												شماره پیگیری: {{ onlineMoneyTransfer.eFardaResult.traceNumber }}
											</div>
											<div class="pa-2">
												شماره مرجع: {{ onlineMoneyTransfer.eFardaResult.refNumber }}
											</div>
											<div class="pa-2">
												توضیحات: {{ onlineMoneyTransfer.eFardaResult.description }}
											</div>
										</v-card>
										<div class="text-center mt-3" v-if="!onlineMoneyTransfer.isSuccess">
											<v-btn color="secondary" dark @click="retryOnlineMoneyTransfer">تلاش مجدد</v-btn>
										</div>
									</div>
								</v-col>
							</v-row>

						</v-col>
					</v-row>
				</div>
			</v-card>

		</v-container>

		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark :loading="submitLoading" @click="submit()">
				ذخیره
			</v-btn>
		</v-card-actions>

		<v-dialog v-model="dialogBankAccounts" scrollable persistent max-width="850px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت حساب های بانکی</span></div>
					<v-spacer />
					<v-btn @click="dialogBankAccounts = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<BankAccounts ref="bankAccounts" v-if="dialogBankAccounts" @callbck="callbck_bankAccounts" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import { emptyId } from '@/util/emptyId'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import { call, get } from 'vuex-pathify'
	import { obj2FormData } from '@/util/helpers.js'
	import { babats, banks, transferTypes } from '@/util/enums.js'

	export default {
		name: 'ModifyLoanPaymentView',
		components: {
			'date-picker': VuePersianDatetimePicker,
			Countdown: () => import('@/components/Countdown'),
			BankAccounts: () => import('@/components/forms/BankAccounts'),
			ImageUploader,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				openbank: 1,
				showMore: false,
				dialogBankAccounts: false,
				onlineMoneyTransferActive: false,
				ignoreOtpValidation: false,
				otpLoading: false,
				ibanInquiryLoading: false,

				validationMsg: '',
				onlineMoneyTransfer: { provider: 1, shahin: {} },
				regLoading: false,
				sendCodeVisible: true,
				overlayImgSrc: '',
				overlay: false,
				errorMessages: '',
				localData: { paymentMethod: 1, base64: '' },
				submitLoading: false,
				targetMonth: '',
				initValue: 0,
				loans: [],
				agents: [],
				marketers: [],
				userLoans: [],
				contacts: [],
				userLoanContacts: [],
				customerMarketerCommissions: [],
				toAccounts: [],
				babats: babats,
				banks: banks,
				transferTypes: transferTypes
			}
		},
		computed: {
			...get('appSettings', [
				'settings'
			]),
			customerStatuses: get('loanRequestStatus/statuses'),
			agentStatuses: get('loanRequestStatus/agentStatuses'),
			isNew() {
				return this.localData.id === emptyId
			},
			transactionTitle() {
				switch (this.data.paymentMethod) {
					case 1:
						return this.data.isWithdraw ? 'برداشت از صندوق' : 'واریز به صندوق'
					case 2:
						return this.data.isWithdraw ? 'برداشت از بانک' : 'واریز به بانک'
					case 3:
						return this.data.isWithdraw ? 'برداشت از جعبه طلا' : 'واریز به جعبه طلا'
					default:
						return 'تراکنش نامعلوم'
				}
			},
			bankAccounts() {
				return this.settings?.bankAccountsJson ? JSON.parse(this.settings.bankAccountsJson).map(x => x.accountNumber) : []
			},
			onlineMoneyTransferColor() {
				if (this.onlineMoneyTransfer.eFardaResult && this.onlineMoneyTransfer.isSuccess)
					return 'success'
				else if (this.onlineMoneyTransfer.eFardaResult && !this.onlineMoneyTransfer.isSuccess)
					return 'red'
				return 'secondary'
			},
			onlineMoneyTransferIcon() {
				if (this.onlineMoneyTransfer.eFardaResult && this.onlineMoneyTransfer.isSuccess)
					return 'mdi-credit-card-check-outline'
				else if (this.onlineMoneyTransfer.eFardaResult && !this.onlineMoneyTransfer.isSuccess)
					return 'mdi-credit-card-remove-outline'
				return 'mdi-credit-card-settings-outline'
			}
		},
		mounted() {
			this.fetch()
			this.prepareData().then(x => {
				if (this.localData.agent)
					this.loadAgents()

				if (this.localData.customerMarketerCommission)
					this.loadMarketers()

				if (this.localData.userLoanRequest)
					this.fetchLoanRequestStatus()
			})
		},
		methods: {
			fetchLoanRequestStatus: call('loanRequestStatus/fetch'),
			...call('appSettings/*'),
			countDownFinished() {
				this.sendCodeVisible = true
			},
			submit() {
				// this.data.maxAmount
				this.validationMsg = ''
				this.ignoreOtpValidation = false
				if (typeof this.data.maxAmount !== 'undefined') {
					if (this.localData.amount > this.data.maxAmount) {
						toast.error('مبلغ وارد شده بیشتر از مانده سهم نماینده است.')
						return
					}
				}
				if (!this.$refs.form.validate()) { return }
				if (this.$refs.formOnlineTransfer && !this.$refs.formOnlineTransfer.validate()) {
					toast.error('لطفا فیلد های فرم انتقال وجه را تکمیل نمایید.')
					return
				}
				let data = {}
				Object.assign(data, this.localData)
				delete data.base64
				delete data.base642
				delete data.base643
				delete data.saveDate_Persian
				if (this.onlineMoneyTransferActive)
					data.onlineMoneyTransfer = this.onlineMoneyTransfer
				const formData = obj2FormData(data)
				var fileUploader = this.$refs['imageUploader'] ? this.$refs['imageUploader'] : null
				if (fileUploader && fileUploader.hasFile()) {
					formData.append('file', fileUploader.getFile())
				}
				var fileUploader2 = this.$refs['imageUploader2'] ? this.$refs['imageUploader2'] : null
				if (fileUploader2 && fileUploader2.hasFile()) {
					formData.append('file2', fileUploader2.getFile())
				}
				var fileUploader3 = this.$refs['imageUploader3'] ? this.$refs['imageUploader3'] : null
				if (fileUploader3 && fileUploader3.hasFile()) {
					formData.append('file3', fileUploader3.getFile())
				}
				this.submitLoading = true
				api.post('admin/transaction/' + (this.localData.id === emptyId ? 'create' : 'edit'), formData, { contentType: 'multipart/form-data' })
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						if (this.onlineMoneyTransferActive) {
							Object.assign(this.onlineMoneyTransfer, response.onlineMoneyTransfer)
							this.localData.id = response.id
						} else {
							this.$emit('callbck', true)
						}
					})
					.catch(err => {
						toast.error(err.message)
						if (this.onlineMoneyTransferActive && err.exception?.data) {
							Object.assign(this.onlineMoneyTransfer, err.exception.data.onlineMoneyTransfer)
						}
					})
					.finally(x => { this.submitLoading = false })
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: emptyId, paymentMethod: 1 }
				}
				if (!this.data.id) {
					this.data.id = emptyId
				}
				return api.get('admin/transaction/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = { ...response }
							if (this.localData.base642 || this.localData.base643)
								this.showMore = true
							if (this.data.id === emptyId)
								Object.assign(this.localData, this.data)
							else {
								this.initValue = response.amount
							}
							if (this.localData.isWithdraw)
								this.loadLoans()
							if (this.data.userLoan) {
								this.userLoans = [this.data.userLoan]
								this.localData.userLoan = this.data.userLoan
								if (this.data.id !== emptyId) {// in create mode, data.userLoan has title but in edit data.userLoan doesn't have title
									this.localData.userLoan.title = `شماره وام: ${this.data.userLoan.code}`
									this.userLoans[0].title = this.localData.userLoan.title
								}
							}
							if (this.data.userLoanContact) {
								this.userLoanContacts = [this.data.userLoanContact]
								this.localData.userLoanContact = this.data.userLoanContact
							}

							if (this.localData.customerMarketerCommission) {
								this.customerMarketerCommissions = [this.localData.customerMarketerCommission]
								// this.localData.customerMarketerCommission = this.data.customerMarketerCommission
							}
							if (this.localData.agent) {
								if (this.localData.agent.bankAccountsJson) {
									this.toAccounts = JSON.parse(this.localData.agent.bankAccountsJson).map(x => { return { value: x.accountNumber, text: `${x.accountNumber} (${x.bank})` } })
									this.onlineMoneyTransfer.to = this.toAccounts.length === 1 ? this.toAccounts[0].value : ''
								}
							}
							if (this.localData.customerMarketerCommission?.marketer) {
								if (this.localData.customerMarketerCommission?.marketer.bankAccountsJson) {
									this.toAccounts = JSON.parse(this.localData.customerMarketerCommission?.marketer.bankAccountsJson).map(x => { return { value: x.accountNumber, text: `${x.accountNumber} (${x.bank})` } })
									this.onlineMoneyTransfer.to = this.toAccounts.length === 1 ? this.toAccounts[0].value : ''
								}
							}
							else if (this.localData.contact) {
								this.onlineMoneyTransfer.to = this.localData.contact.bankInfo
							}
							if (this.localData.onlineMoneyTransfer) {
								Object.assign(this.onlineMoneyTransfer, this.localData.onlineMoneyTransfer)
								this.onlineMoneyTransferActive = true
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadLoans() {
				api.get('admin/loan/list', null)
					.then(
						response => {
							this.loans = response.filter(x => x.isSponsored)
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadAgents() {
				api.get('admin/agent/list/', null)
					.then(
						response => {
							this.agents = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadMarketers() {
				api.get('admin/customermarketer/list/', null)
					.then(
						response => {
							this.marketers = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			viewImage(img) {
				this.overlay = true
				this.overlayImgSrc = img
			},
			sendOTP() {
				this.ignoreOtpValidation = true
				this.validationMsg = ''
				if (!this.localData.amount)
					this.validationMsg = 'مبلغ را وارد کنید'

				if (!this.$refs.form.validate() || !this.$refs.formOnlineTransfer.validate()) { return }

				this.validationMsg = ''
				this.otpLoading = true

				this.onlineMoneyTransfer.amount = this.localData.amount
				api.post('admin/Transaction/SendOTP', this.onlineMoneyTransfer)
					.then(response => {
						this.onlineMoneyTransfer.onlineMoneyTransferPanelId = response
						this.onlineMoneyTransfer.isSuccess = false
						this.onlineMoneyTransfer.eFardaJson = ''
						this.$refs.countdown.start()
						this.sendCodeVisible = false
						this.validationMsg = ''
					})
					.catch(err => {
						this.validationMsg = err.message
					})
					.finally(() => {
						this.otpLoading = false
					})

			},
			ibanInquiry() {
				this.validationMsg = ''
				if (!this.onlineMoneyTransfer.to)
					this.validationMsg = 'شماره شبا را وارد کنید'

				this.ibanInquiryLoading = true

				api.get('admin/Transaction/IbanInquiry/' + this.onlineMoneyTransfer.shahin.destinationAccountNumber)
					.then(response => {
						this.onlineMoneyTransfer.toName = response
						this.validationMsg = ''
					})
					.catch(err => {
						this.validationMsg = err.message
					})
					.finally(() => {
						this.ibanInquiryLoading = false
					})

			},

			callbck_bankAccounts() {
				this.dialogBankAccounts = false
			},
			retryOnlineMoneyTransfer() {
				this.onlineMoneyTransfer = {
					eFardaResult: null,
					from: this.onlineMoneyTransfer.from,
					to: this.onlineMoneyTransfer.to
				}
				this.sendCodeVisible = true
			}
		},
	}
</script>
<style></style>
